import apiService from "../common/commonApi";

export const shiftControl = {};

shiftControl.list = async (param) => {    
    return apiService.Get('shiftcontrol-list', param);
}
